<template>
  <div>
    <headline-container headline="Meetings" :breadcrumbs="[{text: 'Meetings'}]"/>

    <div class="container">
      <filter-form v-model="filters"/>

      <hr>

      <div class="row">
        <div class="col-sm-24">
          <overview-panel :filters="filters"/>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-24">
          <list-panel :filters="filters"/>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-8">
          <legend-panel/>
        </div>

        <div class="col-sm-16">
          <by-user-panel :filters="filters"/>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-24">
          <by-week-panel :filters.sync="filters"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ByUserPanel from '@/components/Dashboards/Meetings/ByUserPanel'
import ByWeekPanel from '@/components/Dashboards/Meetings/ByWeekPanel'
import FilterForm from '@/components/Dashboards/Meetings/FilterForm'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import LegendPanel from '@/components/Dashboards/Meetings/LegendPanel'
import ListPanel from '@/components/Dashboards/Meetings/ListPanel'
import OverviewPanel from '@/components/Dashboards/Meetings/OverviewPanel'

export default {
  components: {ByUserPanel, ByWeekPanel, FilterForm, HeadlineContainer, LegendPanel, ListPanel, OverviewPanel},

  data() {
    return {
      filters: {
        starts_from: moment().startOf('isoweek').format('YYYY-MM-DD'),
        starts_to: moment().endOf('isoweek').format('YYYY-MM-DD'),
      },
    }
  },

  mounted() {
    this.load()
  }
}
</script>
